import { gql } from "@apollo/client";


export const SET_LOG_ACESSO_RECURSOS = gql`
mutation SetLogAcessoRecursos($log: log_acessos!) {
  SetLogAcessoRecursos(log: $log) {
    id
  }
}
`